import React, { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bell } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = async () => {
    try { const { data } = await api.get("/notifications"); setItems(data.items || []); } catch {}
  };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read"); load(); };
  return (
    <DashboardLayout title="Notifications" actions={<Button variant="outline" data-testid="mark-all-btn" onClick={markAll}>Mark all read</Button>}>
      <Card>
        <CardHeader><CardTitle className="font-heading tracking-tight">Recent activity</CardTitle></CardHeader>
        <CardContent>
          {items.length === 0 && <div className="py-10 text-center text-sm text-muted-foreground" data-testid="notifications-empty">Nothing here yet.</div>}
          <div className="divide-y divide-border">
            {items.map((n) => (
              <div key={n.id} className="py-4 flex items-start gap-3" data-testid={`notif-${n.id}`}>
                <div className="w-10 h-10 rounded-md bg-primary/10 text-primary grid place-items-center shrink-0"><Bell className="w-4 h-4" /></div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between gap-2">
                    <div className="font-medium text-secondary">{n.title}</div>
                    {!n.read && <span className="w-2 h-2 rounded-full bg-primary shrink-0" />}
                  </div>
                  <div className="text-sm text-muted-foreground">{n.body}</div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
}
